import React from "react";

export default function TermsConditions() {
  return (
    <div className="relative overflow-hidden bg-[#FFF8EE] pt-28 pb-20 min-h-screen">
      {/* Background Gradients */}
      <div className="absolute top-[-250px] left-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.12)_0%,transparent_70%)] pointer-events-none" />
      <div className="absolute bottom-[-300px] right-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.1)_0%,transparent_70%)] pointer-events-none" />

      <div className="relative z-20 max-w-[960px] mx-auto px-6">
        <div className="rounded-[40px] border border-[#F4D9B5] bg-white/70 backdrop-blur-2xl p-8 md:p-14 shadow-[0_20px_60px_rgba(0,0,0,0.03)]">
          <h1 className="text-[36px] md:text-[50px] font-bold text-[#111111] font-poppins mb-4" style={{ fontFamily: "Poppins" }}>Terms & Conditions</h1>
          <p className="text-xs text-[#777] mb-10">Last Updated: June 29, 2026</p>
          
          <div className="prose max-w-none text-[#444] text-[15px] leading-[30px] space-y-8">
            <p>
              Please read these terms and conditions carefully before using the Divyyog Foundation website or purchasing any wellness membership plan. By accessing or using our platform, you agree to be bound by these terms.
            </p>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>1. Account Registration</h2>
              <p>
                To access live batches and course libraries, you must register a user account. You are responsible for keeping your credentials confidential and agree to notify us immediately of any unauthorized account activity. You must be at least 18 years old (or have parental supervision) to register.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>2. Medical Disclaimer</h2>
              <p>
                Yoga, breathing, and meditation sessions are designed to support overall physical and mental wellness. However:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Classes are not a substitute for professional medical advice, diagnosis, or treatment.</li>
                <li>You are responsible for assessing your physical health and consulting a doctor before participating.</li>
                <li>If you experience pain, dizziness, or discomfort during a session, you should stop immediately.</li>
                <li>Divyyog Foundation is not liable for injuries resulting from practicing class routines at home.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>3. Subscriptions & Payments</h2>
              <p>
                Certain wellness batches require paid subscriptions. By subscribing, you agree to pay all charges specified at checkout. Subscriptions are billed in advance on a recurring monthly or annual basis. You may cancel your renewal at any time through your dashboard.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>4. Intellectual Property</h2>
              <p>
                All videos, images, branding materials, curriculum, and class recordings are the intellectual property of Divyyog Foundation. You are granted a limited, personal, non-transferable license to access content for personal wellness practices. Recording, downloading, or redistributing classes is strictly prohibited.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>5. Contact Us</h2>
              <p>
                If you have questions regarding these terms, please contact us at <strong>legal@divyyog.org</strong> or visit our <a href="/contact" className="text-[#F29A0C] font-semibold hover:underline">Contact Page</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
